<template>
  <div
    class="third-page-root"
    ref="navBox"
    :class="{ 'a-fadeinB': changeClassName }"
  >
    <div class="third-page-root-content">
      <div class="title">产品优势</div>
      <div class="really-box">
        <div class="left-content">
          <div class="flex-align-center">
            <div class="shu-xian"></div>
            <div class="font">业主真实房源</div>
          </div>
          <div style="margin-top: 40px" class="font1">
            楼域平台上的所有房源都是由业主发布的真实房源。且平台严格执行实名认证与房源审核机制，确保所有上线房源的真实性与有效性杜绝虚假信息。租客可以最直接联系到业主，减少了中间环节。降低了租客的成本，同时也提高了租房效率
          </div>
        </div>
        <div class="right-content">
          <img
            src="../../assets/displayPage/third.png"
            alt=""
            class="right-content"
          />
        </div>
      </div>

      <div class="row-box">
        <div class="row-box-item">
          <div>
            <div class="flex-align-center">
              <div class="shu-xian"></div>
              <div class="font">直客模式</div>
            </div>
            <div style="margin-top: 40px" class="font1">
              通过楼域平台业主可以直接对接租客，省去中间环节，无须支付高昂的中介费
            </div>
          </div>
          <img
            src="../../assets/displayPage/fifth.png"
            alt=""
            class="bottom-img"
          />
        </div>
        <div class="row-box-item">
          <div>
            <div class="flex-align-center">
              <div class="shu-xian"></div>
              <div class="font">安全保障</div>
            </div>
            <div style="margin-top: 40px" class="font1">
              采用先进的数据加密技术，保护用户个人信息及交易数据安全
            </div>
          </div>
          <img
            src="../../assets/displayPage/fourth.png"
            alt=""
            class="bottom-img"
          />
        </div>
        <div class="row-box-item">
          <div>
            <div class="flex-align-center">
              <div class="shu-xian"></div>
              <div class="font">数据分析</div>
            </div>
            <div style="margin-top: 40px" class="font1">
              为业主提供房源浏览量、预约看房次数、成交转化率等运营数据，帮助优化房源展示提升出租效率。同时，通过大数据分析，为业主提供区域租金走势、租客需求洞察等市场情报，辅助决策
            </div>
          </div>
          <img
            src="../../assets/displayPage/sixth.png"
            alt=""
            class="bottom-img1"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      observer: null,
      changeClassName: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.setObserver();
  },
  beforeDestroy() {
    this.disconnectObservers();
  },
  methods: {
    disconnectObservers() {
      if (this.observer) {
        this.observer.unobserve(this.$refs.navBox); //解绑元素
        this.observer.disconnect(); //停止监听
      }
    },
    setObserver() {
      this.observer = new IntersectionObserver((entries) => {
        // this.timeOut = setTimeout(() => {
        this.changeClassName = entries[0].isIntersecting;
        // clearTimeout(this.timeOut)
        // this.timeOut = null
        // }, 500)
      });
      this.observer.observe(this.$refs.navBox);
    },
  },
};
</script>

<style lang="scss" scoped>
.third-page-root {
  width: 100%;
  height: 891px;
  background: linear-gradient(180deg, #ffffff 0%, #faf8f8 22%, #f7faff 100%);
  .third-page-root-content {
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    .title {
      margin: 0 auto;
      padding: 72px 0 56px 0;
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 400;
      font-size: 32px;
      color: #121218;
      line-height: 46px;
      text-align: center;
    }
    .really-box {
      width: 100%;
      height: 296px;
      box-sizing: border-box;
      padding: 18px 18px 18px 28px;
      display: flex;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      align-items: center;
      justify-content: space-between;
      .left-content {
        margin-right: 56px;
      }
      .right-content {
        width: 627px;
        height: 260px;
      }
    }
  }
}

.shu-xian {
  width: 4px;
  height: 20px;
  background: #0262f6;
  margin-right: 10px;
}

.font {
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 24px;
  color: #121218;
  line-height: 35px;
}

.flex-align-center {
  display: flex;
  align-items: center;
}

.font1 {
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 16px;
  color: #3d3d3d;
  line-height: 28px;
}

.row-box {
  margin-top: 56px;
  width: 1200px;
  height: 293px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .row-box-item {
    width: 380px;
    height: 293px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    padding: 28px 40px 0 28px;
    box-sizing: border-box;
    position: relative;
    & > div {
      position: relative;
      left: 0;
      top: 0;
      z-index: 1;
    }
  }
}

.bottom-img {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 160px;
  height: 144.89px;
}
.bottom-img1 {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 165.5px;
  height: 95px;
  z-index: 0;
}
.a-fadeinB {
  animation: fadeinB 1s ease-out backwards;
}
@keyframes fadeinB {
  0% {
    opacity: 0;
    transform: translate3d(0, 10%, 0);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
    transform: translate3d(0, 0, 0);
  }
}
</style>
